module.exports = __webpack_public_path__ + "static/media/bolivia.98aa2761.svg";